import * as Sentry from '@sentry/browser'
import { i18n } from './i18n'

// Layout::Component::Head loads the translations as a separate locale_<lang> module script ahead of the
// application entrypoint. Module scripts run in document order, so if the translations are absent by the time this
// runs, that script failed to load: a network error, or stale HTML naming a locale file a later deploy removed.
// Every i18n.t would then throw and take its Stimulus controller down with it, so reload once to fetch the page
// again, and if that does not help either, fall back to guessed labels and report it.
const RELOAD_MARKER_KEY = 'luca:locale-reload-at'
const RELOAD_WINDOW_MS = 60_000

function reloadedRecently(): boolean {
  try {
    const reloadedAt = Number(sessionStorage.getItem(RELOAD_MARKER_KEY))
    if (Date.now() - reloadedAt < RELOAD_WINDOW_MS) return true

    sessionStorage.setItem(RELOAD_MARKER_KEY, String(Date.now()))
    return false
  } catch {
    // Without storage there is no way to tell a first attempt from a reload loop.
    return true
  }
}

function reportMissingLocale(locale: string) {
  const localeScript = performance
    .getEntriesByType('resource')
    .find((entry): entry is PerformanceResourceTiming => entry.name.includes(`/locale_${locale}`))

  Sentry.captureMessage(`Locale bundle ${locale} did not load`, {
    level: 'warning',
    extra: {
      localeScriptUrl: localeScript?.name,
      responseStatus: localeScript?.responseStatus,
      transferSize: localeScript?.transferSize,
    },
  })
}

if (!(i18n.locale in i18n.translations)) {
  // Whatever evaluates before the reload navigates away must not throw on every label.
  i18n.missingBehavior = 'guess'

  if (reloadedRecently()) {
    reportMissingLocale(i18n.locale)
  } else {
    window.location.reload()
  }
}
